<template>
  <div class="page-wrapper">
    <TrfGlobalLoader v-if="isEdicaoLoading" v-e2e="'template-loader'" type="fixed" />
    <div class="container">
      <TrfToolbarTextEditorInline
        id="cadastro-form-titulo"
        class="inline-titulo-form"
        :class="{'has-error': !isTituloFormValido}"
        tag="h1"
        :is-obrigatorio="true"
        :editorStyle="`h1.mce-content-body { font-size: 36px; color: #333!important; padding-bottom: 1rem; border-bottom: 2px solid #66666600; transition: border 0.35s ease-in-out 0s} h1.mce-content-body:focus-visible, h1.mce-content-body:hover { outline: 0 none; border-bottom: 2px solid ${estilosPadrao.CorPrimaria}FF}`"
        @changeText="setNome"
        ref="tituloRef"
      ></TrfToolbarTextEditorInline>
        <div class="is-relative">
          <ul class="modal-tabs has-text-weight-bold is-justify-content-center">
            <li><a :class="{'is-active': currentTab === Tabs.EMPRESA}" @click="selecionarTab(Tabs.EMPRESA)"><span>Formulário da empresa &nbsp;</span></a></li>
            <li><a :class="{'is-active': currentTab === Tabs.SOCIO}" @click="selecionarTab(Tabs.SOCIO)"><span>&nbsp; Formulário do sócio &nbsp;</span></a></li>
            <li><a :class="{'is-active': currentTab === Tabs.VISUALIZACAO}" @click="selecionarTab(Tabs.VISUALIZACAO)"><span>&nbsp; Visualizar</span></a></li>
          </ul>
        </div>
        <div v-show="isTabEmpresaSelecionada" :class="{'is-flex': isTabEmpresaSelecionada, 'is-justify-content-center': isTabEmpresaSelecionada}">
            <TrfDraggable pKeyAttribute="uuid" :pItems="formData.camposEmpresa" pGroupName="campo-formulario-empresa-novo" :pUseCustomHandler="true" pCustomHandlerClass="drag-handle" style="max-width:744px;width:100%;" @changed:items="setItemsEmpresa">
              <template #item="{item, index}">
                <div class="box-edicao is-relative" :class="{'has-error': item.hasErrorTitulo || item.hasErrorOpcoes}" tabindex="-1" @focusout="setLastFocusItem(item)">
                  <a class="button is-primary drag-handle drag-handle-body"><span class="mdi mdi-drag-horizontal-variant drag-handle"></span></a>
                  <TrfCampoForm :item="item" :order="index" @delete:campo="removerCampoEmpresa($event, index)" :ref="`campo-empresa-${item.uuid}`" @update:form-data="($event) => updateCampoEmpresa($event)"></TrfCampoForm>
                </div>
              </template>
            </TrfDraggable>
            <TrfAddButton class="is-add-button-component" @insert:campo="inserirCampoEmpresa"></TrfAddButton>
        </div>
        <div v-show="isTabSocioSelecionada" :class="{'is-flex': isTabSocioSelecionada, 'is-justify-content-center': isTabSocioSelecionada}">
            <TrfDraggable pKeyAttribute="uuid" :pItems="formData.camposSocio" pGroupName="campo-formulario-socio-novo" :pUseCustomHandler="true" pCustomHandlerClass="drag-handle" style="max-width:744px;width:100%;" @changed:items="setItemsSocio">
              <template #item="{item, index}">
                <div class="box-edicao is-relative" :class="{'has-error': item.hasErrorTitulo || item.hasErrorOpcoes}" tabindex="-1" @focusout="setLastFocusItem(item)">
                  <a class="button is-primary drag-handle drag-handle-body"><span class="mdi mdi-drag-horizontal-variant drag-handle"></span></a>
                  <TrfCampoForm :item="item" :order="index" @delete:campo="removerCampoSocio($event, index)" :ref="`campo-socio-${item.uuid}`" @update:form-data="($event) => updateCampoSocio($event)"></TrfCampoForm>
                </div>
              </template>
            </TrfDraggable>
            <TrfAddButton class="is-add-button-component" @insert:campo="inserirCampoSocio"></TrfAddButton>
        </div>
        <div v-show="isTabVisualizarSelecionada" :class="{'is-flex': isTabVisualizarSelecionada, 'is-justify-content-center': isTabVisualizarSelecionada}">
          <TrfVisualizarForm :pFormData="formData"></TrfVisualizarForm>
        </div>
        <hr />
        <div class="columns is-justify-content-flex-end pb-5 action-box">
          <div class="column is-narrow">
            <TrfButton
              @click="doSalvar"
              v-e2e="'novo-formulario-btn-salvar'"
              :nome="isEdicao ? 'Salvar' : 'Cadastrar'"
              classCor="is-primary"
              id="novo-form-btn-salvar"
              :isBtnLoading="isSalvando"
            />
          </div>
          <div class="column is-narrow">
            <TrfButton
              @click="doCancelar"
              v-e2e="'visualizar-formulario-btn-cancelar'"
              nome="Cancelar"
              id="novo-form-btn-cancelar"
              :disabled="isSalvando"
            />
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { routerUtils } from '../../../util/router.utils';
import { stylesUtils } from '../../../util/styles.utils';
import { gerarUUID } from '../../../util/uuid.utils';
import { camposPadraoEmpresa, camposPadraoSocio } from '../../../components/CampoForm/configs/campos.config';
import CampoPersonalizado from '../../../components/CampoForm/models/campoPersonalizado.model';
import Formulario from '../../../model/formulario.model.js';
import { tipoInputEnum } from '../../../components/CampoForm/enum/TipoInput.enum.js';
import { ToastBuilder, toastTypeEnum } from '../../../builder/toast.builder.js';

const CADASTRO_SUCESSO_TOAST = new ToastBuilder();
CADASTRO_SUCESSO_TOAST.setDuration(3000);
CADASTRO_SUCESSO_TOAST.setType(toastTypeEnum.SUCCESS)

const CADASTRO_ERROR_TOAST = new ToastBuilder();
CADASTRO_ERROR_TOAST.setDuration(3000);
CADASTRO_ERROR_TOAST.setType(toastTypeEnum.DANGER)

export default {
  name: "TrfNovoFormulario",
  components: {
    TrfGlobalLoader: defineAsyncComponent(() => import('../../../components/GlobalLoader/index.vue')),
    TrfToolbarTextEditorInline: defineAsyncComponent(() => import('../../../components/ToolbarTextEditor/inline.vue')),
    TrfDraggable: defineAsyncComponent(() => import('../../../components/Draggable/index.vue')),
    TrfCampoForm: defineAsyncComponent(() => import('../../../components/CampoForm/index.vue')),
    TrfAddButton: defineAsyncComponent(() => import('../../../components/CampoForm/components/AddButton.vue')),
    TrfVisualizarForm: defineAsyncComponent(() => import('../../../components/VisualizarForm/index.vue')),
    TrfButton: defineAsyncComponent(() => import('../../../components/Button/index.vue'))
  },
  async beforeRouteEnter(to, from, next) {
    const id = to.params?.id;
    next(async (vm) => await vm.carregarDadosEdicao(id));
  },
  async beforeRouteUpdate(to) {
    const id = to.params?.id;
    await this.carregarDadosEdicao(id);
  },
  props: {
  },
  data() {
    const Tabs = {
      EMPRESA: 0,
      SOCIO: 1,
      VISUALIZACAO: 2
    }
    return {
      Tabs: Tabs,
      currentTab: Tabs.EMPRESA,
      isFormLoading: false,
      estilosPadrao: '',
      focusedItem: null,
      formModel: new Formulario(),
      formData: {
        nomeHtml: '<h1>Título formulário</h1>',
        nome: 'Título formulário',
        camposEmpresa: [...camposPadraoEmpresa],
        camposSocio: [...camposPadraoSocio]
      },
      modalVisualizarSocio: {
        isActive: false
      },
      isSalvando: false,
      isEdicaoLoading: false,
      isEdicao: false
    }
  },
  computed: {
    isTabEmpresaSelecionada() {
      return this.currentTab === this.Tabs.EMPRESA
    },
    isTabSocioSelecionada() {
      return this.currentTab === this.Tabs.SOCIO
    },
    isTabVisualizarSelecionada() {
      return this.currentTab === this.Tabs.VISUALIZACAO
    },
    isTituloFormValido() {
      // proteção referente a nomes iguais é feita no back!
      return !!this.formData.nome.trim() && !!this.formData.nomeHtml.trim()
    },
  },
  watch: {
    formData: {
      immediate: true,
      handler(novo, antigo) {
        this.updateModel()
      },
      deep: true
    }
  },
  methods: {
    async importTemplateFormularioService() {
      const { templateFormularioService } = await import('../../../service/template-formulario-service');
      return templateFormularioService
    },
    setItemsEmpresa(items) {
      if (!items) return [];
      this.formData.camposEmpresa = items
      this.updateModel()
    },
    setItemsSocio(items) {
      if (!items) return [];
      this.formData.camposSocio = items
      this.updateModel()
    },
    updateCampoEmpresa(formData) {
      const index = this.formData.camposEmpresa.findIndex(campo => (campo.id && campo.id == formData.id) || campo.uuid == formData.uuid);
      this.formData.camposEmpresa[index] = formData;
      this.updateModel()
    },
    updateCampoSocio(formData) {
      const index = this.formData.camposSocio.findIndex(campo => (campo.id && campo.id == formData.id) || campo.uuid == formData.uuid);
      this.formData.camposSocio[index] = formData;
      this.updateModel()
    },
    async inserirCampoEmpresa() {
      const focusedItem = await Promise.resolve(this.focusedItem);
      const newItem = new CampoPersonalizado();
      newItem.updateDados({
        titulo: "Pergunta",
        tituloHtml: "<p>Pergunta</p>",
        tipoInput: "TEXT",
        uuid: gerarUUID()
      })
      if (!focusedItem) {
        this.formData.camposEmpresa.unshift(newItem)
      } else {
        const index = this.formData.camposEmpresa.findIndex(item => (item.id && item.id == focusedItem.id) || item.uuid == focusedItem.uuid);
        this.formData.camposEmpresa.splice(index+1, 0, newItem)
      }
      this.focusedItem = null

      await this.$nextTick();
      const newItemRef = this.$refs[`campo-empresa-${newItem.uuid}`];
      await newItemRef.setSelecionaTituloNoReady()
    },
    async inserirCampoSocio() {
      const focusedItem = await Promise.resolve(this.focusedItem);
      const newItem = new CampoPersonalizado();
      newItem.updateDados({
        titulo: "Pergunta",
        tituloHtml: "<p>Pergunta</p>",
        tipoInput: "TEXT",
        isCampoSocio: true,
        uuid: gerarUUID()
      })
      if (!focusedItem) {
        this.formData.camposSocio.unshift(newItem)
      } else {
        const index = this.formData.camposSocio.findIndex(item => (item.id && item.id == focusedItem.id) || item.uuid == focusedItem.uuid);
        this.formData.camposSocio.splice(index+1, 0, newItem)
      }
      this.focusedItem = null

      await this.$nextTick();
      const newItemRef = this.$refs[`campo-socio-${newItem.uuid}`];
      await newItemRef.setSelecionaTituloNoReady()
    },
    setNome(nomeHtml, field) {
      this.formData.nomeHtml = nomeHtml? nomeHtml : ''; // Garante tipagem
      this.formData.nome = field.getValueAsText()? field.getValueAsText() : '';
    },
    updateModel() {
      this.formModel.updateDados(this.formData);
    },
    async carregarDadosEdicao(id) {
      if(!id) return;
      this.isEdicao = true;
      this.isEdicaoLoading = true;
      try {
        const templateFormularioService = await this.importTemplateFormularioService()
        const form = await templateFormularioService.adquirirPorId(id);
        const formData = new Formulario();
        formData.asModel(form);
        const titulo = formData.nomeHtml ? formData.nomeHtml : formData.nome;
        this.$refs.tituloRef.iniciarTextEditorComValor(titulo)
        this.formData = formData;
        this.isEdicaoLoading = false
      } catch (e) {
        console.warn(e);
        routerUtils._carregarNovaRota("/formularios/")
      }
      this.isEdicaoLoading = false;
    },
    selecionarTab(tab) {
      this.focusedItem = null
      this.currentTab = tab
    },
    async setLastFocusItem(item) {
      this.focusedItem = new Promise((resolve, reject) => {
        setTimeout(() => {
          const activeElement = document.activeElement;
          const isActiveElementAddButton = activeElement.classList && activeElement.classList.contains('is-add-button');
          const resolvedItem = isActiveElementAddButton? item : null;
          resolve(resolvedItem)
        },0) // Resolve no proximo ciclo para garantir execução de eventos nativos.
      })
    },
    removerCampoEmpresa(item, index) {
      this.formData.camposEmpresa.splice(index, 1)
    },
    removerCampoSocio(item, index) {
      this.formData.camposSocio.splice(index, 1)
    },
    doCancelar() {
      routerUtils._carregarNovaRota("/formularios/")
    },
    async doSalvar() {
      try {
        this.isSalvando = true;
        const isFormValid = await this.validarCamposPersonalizados();
        if (!isFormValid.status) {
          throw new Error(`${isFormValid.message}`) //garante tipagem
        }
        const templateFormularioService = await this.importTemplateFormularioService();
        await templateFormularioService.salvar(this.formModel.asRequestBody());
        CADASTRO_SUCESSO_TOAST.setMessage(this.formModel.id? "Formulário editado com sucesso!" : "Formulário cadastrado com sucesso!");
        CADASTRO_SUCESSO_TOAST.toast()
        this.isSalvando = false;
        routerUtils._carregarNovaRota("/formularios/")
      } catch (e) {
        const message = e.message? e.message : e;
        console.warn(message);
        CADASTRO_ERROR_TOAST.setMessage(message);
        CADASTRO_ERROR_TOAST.toast();
        this.isSalvando = false;
      }
    },
    async validarCamposPersonalizados() {
      let message = '';

      const isTituloFormValido = this.isTituloFormValido;
      if (!isTituloFormValido) {
        message += 'O título do formulário é obrigatório.\n';
      }

      const isTitulosCamposValidos = await this.validarTitulosCampos();
      if (!isTitulosCamposValidos) {
        message += 'O título para perguntas é obrigatório.\n';
      }

      const isCamposHasOpcoes = await this.validarCamposHasOpcoes();
      if (!isCamposHasOpcoes) {
        message += 'Perguntas com multiplas opções devem ter ao menos uma opção, e as descrições são obrigatórias!';
      }

      return {
        status: isTituloFormValido & isTitulosCamposValidos & isCamposHasOpcoes,
        message: message
      }
    },
    async validarTitulosCampos() {
      const todosOsCampos = [...this.formData.camposEmpresa, ...this.formData.camposSocio];
      const isTituloCamposEmpresasValido = todosOsCampos.every((campo) => {
        if (!!campo.blocoPadrao) {
          return true
        }

        const isTituloValido = !!campo.titulo && !!campo.tituloHtml

        campo.hasErrorTitulo = !isTituloValido

        return isTituloValido
      })

      return isTituloCamposEmpresasValido
    },
    async validarCamposHasOpcoes() {
      const todosOsCampos = [...this.formData.camposEmpresa, ...this.formData.camposSocio];
      const isOpcoesCaposValidos = todosOsCampos.every((campo) => {
        if (!this.isPersonalizadoComOpcoes(campo) || campo.hasOpcaoOutro) {
          return true
        }
        const isOpcaoValida = Array.isArray(campo.opcoes) && campo.opcoes.length > 0 && campo.opcoes.every(opcao => {
          return !!opcao.label && !!opcao.labelHtml
        })

        campo.hasErrorOpcoes = !isOpcaoValida

        return isOpcaoValida
      })

      return isOpcoesCaposValidos
    },
    isPersonalizadoComOpcoes(campo) {
      return !campo.blocoPadrao && (campo.tipoInput == tipoInputEnum.RADIO.getKey() || campo.tipoInput == tipoInputEnum.CHECKBOX.getKey() || campo.tipoInput == tipoInputEnum.SELECT.getKey());
    }
  },
  async created() {
    this.estilosPadrao = stylesUtils.adquirirEstilosCookie();
  },
  async mounted() {
    this.updateModel();
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../assets/sass/variables.scss';
  .econtador-tab-line {
    position: absolute;
    bottom: 1px;
    width: 100%;
    height: 1px;
    background-color: #000;
    z-index: -4;
    margin:0;
  }
  .box-edicao {
    border-top:.75rem solid var(--primaryColor, #a82339);
    border-left:1rem solid #666666;
    border-radius:8px;
    padding:2em;
    width:100%;
    max-width:744px;
    box-sizing: border-box;
    box-shadow:2px 2px 2px #70757a66;
    transition: border 0.35s ease 0s;
    &:focus, &:focus-within, &:focus-visible, &:active, &:target {
      border-left: 1rem solid var(--primaryColor, $primary);
    }
  }
  .is-add-button-component {
    position: sticky;
    top: calc(53px + 1.25rem);
    align-self: flex-start;
    background: #FFF;
    padding: 0.75rem;
    margin-left: 1rem;
    margin-top: 1.25rem;
    box-shadow: 1px 1px 2px 1px rgba(112, 117, 122, 0.4);
  }
  @media screen and (max-width: 768px) {
    .is-add-button-component {
      position: fixed;
      margin-top: 0;
      margin-left: 0;
      top: calc(53px + 1.25rem);
      right: 0;
    }
  }
  .drag-handle-body {
    position: absolute;
    top: -0.75rem;
    left: -1rem;
    width: calc(100% + 1rem);
    border-radius: 6px 6px 0px 0px;
    height: 0.75rem;
    font-size: 0.75rem;
    font-weight: bold;
    cursor: grab;
  }
</style>
<style lang="scss">
  .inline-titulo-form.has-error #cadastro-form-titulo {
    border-bottom-color: #a94442FF!important;
  }
</style>